module.exports = {
  "userStatus": [
    { label: "Activated Only", value: 1 },
    { label: "Disable Only", value: 2 },
  ],
  "resourceStatus": [
    { label: "Draft", value: 0 },
    { label: "Enabled", value: 1 },
    { label: "Disabled", value: 2 },
  ],
  "resourceStatus2": [
    { label: "Enabled", value: 1 },
    { label: "Disabled", value: 2 },
  ],
  "resourceStatusSound": [
    { label: "Draft", value: 0 },
    { label: "Enabled", value: 1 },
  ],
  "resourceCompressionStatus": [
    { label: "Processing", value: 1 },
    { label: "Done", value: 2 },
    { label: "Failed", value: 3 },
  ],
  "musicType": [],
  "soundType": [],
  "TeamList": {},
  "combination": [],
  "exerciseType": [{
    value: 'zhinan',
    label: '指南',
  }],
  "workoutType": [],
  exerciseTypeEditor: [],
  "bodyPart": [],
  "target": [],
  "position": [],
  "focus": [],
  "equipment": [],
  "specialNeed": [],
  "intensity2": [
    { value: 3, label: 'level 1' },
    { value: 5, label: 'level 2' },
    { value: 8, label: 'level 2' },
    { value: 12, label: 'level 3' },
  ],
  "intensity":[
    { label: "level 1" },
    { label: "level 2" },
    { label: "level 3" },
  ],
  "difficulty":[
    { label: "Beginner" },
    { label: "Intermediate" },
    { label: "Advanced" },
  ],
  "difficulty2": [
    { value: 1, label: 'Beginner' },
    { value: 2, label: 'Beginner' },
    { value: 3, label: 'Intermediate' },
    { value: 4, label: 'Intermediate' },
    { value: 5, label: 'Advanced' },
  ],
  "met": [
    { label: 3 },
    { label: 5 },
    { label: 8 },
    { label: 12 },
  ],
  "star": [
    { label: 1 },
    { label: 2 },
    { label: 3 },
    { label: 4 },
    { label: 5 },
  ],
  "subscription":[
    {value:0,label:'Free'},
    {value:1,label:'Non-Free'},
  ],
  "menuList": []
}